import {
  ErrorIcon,
  InfoIcon,
  SuccessIcon,
  WarningIcon,
} from "@/components/icons/graphic";
import { ToastType } from "@/providers/ToastProvider";
import { XIcon } from "lucide-react";

export default function ToastNotification({
  toast,
  onClose,
}: {
  toast: ToastType;
  onClose: () => void;
}) {
  return (
    <div className="p-4">
      <div className="flex items-start">
        <div className="shrink-0">
          <ToastIcon toastType={toast.type} />
        </div>
        <div className="ml-3 w-0 flex-1 pt-0.5">
          <p className="text-sm font-medium wrap-break-word">{toast.title}</p>
          {toast.description && (
            <div className="mt-1 text-sm wrap-break-word text-muted-foreground">
              {toast.description}
            </div>
          )}
        </div>
        <div className="ml-4 flex shrink-0">
          <button
            type="button"
            className="inline-flex rounded-md focus:ring-2 focus:ring-offset-2 focus:outline-hidden"
            onClick={() => onClose()}
          >
            <span className="sr-only">Close</span>
            <XIcon className="size-5" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
}

const ToastIcon = (props: { toastType: ToastType["type"] }) => {
  switch (props.toastType) {
    case "success":
      return <SuccessIcon className="size-8" aria-hidden="true" />;
    case "error":
      return <ErrorIcon className="size-8" aria-hidden="true" />;
    case "warning":
      return <WarningIcon className="size-8" aria-hidden="true" />;
    case "info":
      return <InfoIcon className="size-8" aria-hidden="true" />;
    default:
      return null;
  }
};
